import React, {useState, useContext} from "../../_snowpack/pkg/react.js";
import Notification from "../components/Notification.js";
import SearchBar from "../components/SearchBar.js";
import SearchResults from "../components/SearchResults.js";
import {SettingsContext} from "../App.js";
const HomePage = () => {
  const [query, setQuery] = useState("");
  const [settings] = useContext(SettingsContext);
  const search = (event, nameQuery) => {
    event.preventDefault();
    setQuery(nameQuery);
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: settings.darkMode ? "dark" : ""
  }, /* @__PURE__ */ React.createElement("div", {
    className: "min-h-screen h-full dark:bg-gray-600 pb-[2px]"
  }, /* @__PURE__ */ React.createElement(SearchBar, {
    search
  }), /* @__PURE__ */ React.createElement(SearchResults, {
    name: query
  }), /* @__PURE__ */ React.createElement(Notification, null)));
};
export default HomePage;
